import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import {
  AbstractNewRelicService,
  AbstractPlayButtonSpinnerService,
  AbstractRecommendationService,
  AGE_RATE_FILTER_SERVICE,
  KIDS_PROFILE_FILTER_SERVICE,
  MpxModule,
} from 'osn-shared';
import { MsalGuard } from './guards/msal.guard';
import { TokenInterceptor } from './interceptors/auth.interceptor';
import { AgeRateFilterService } from './services/age-rate-filter.service';
import { KidsProfileFilterService } from './services/kids-profile-filter.service';
import { MockPlayButtonSpinnerService } from './services/mock-play-button-spinner.service';
import { MockRecommendationService } from './services/mock-recommendation.service';
import { NewRelicService } from './services/new-relic.service';

@NgModule({
  imports: [MpxModule],
  providers: [
    MsalGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    { provide: KIDS_PROFILE_FILTER_SERVICE, useClass: KidsProfileFilterService },
    { provide: AGE_RATE_FILTER_SERVICE, useClass: AgeRateFilterService },
    { provide: AbstractNewRelicService, useClass: NewRelicService },
    { provide: AbstractRecommendationService, useExisting: MockRecommendationService },
    { provide: AbstractPlayButtonSpinnerService, useExisting: MockPlayButtonSpinnerService },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
